i<template>
	<div id="wrapper" class="container">
	    <div class="code_box">
			<div style="text-align:left;font-size:0.44rem;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);line-height:0.6rem;">请输入验证码</div>
	        <div style="text-align:left;margin-top:.3rem;font-size:0.28rem;font-family:PingFangSC-Regular;font-weight:400;color:rgba(136,136,136,1);line-height:0.4rem;">为确保是您本人操作，请完成以下验证：</div>
	        <div style="text-align:left;;margin-top:.2rem;font-family:PingFangSC-Regular;font-weight:400;color:rgba(136,136,136,1);line-height:0.4rem;">我们已经发送了验证码到您的手机：{{phoneStr}}</div>
	       	<div class="telcode-box font0">
				<span class="code-span" :class="[{active:item<=codeNumber.length}]" v-for="(item, index) in codeLength" :key="index">{{codeNumber[index] || placeholder}}</span>
			</div>
			<input ref="input" class="input-code" @keyup="handleInput($event)" v-model="codeNumber" id="code" name="code" type="tel" :maxlength="codeLength"
           autocorrect="off" autocomplete="off" autocapitalize="off"  οninput="if(value.length>6)value=value.slice(0,6)">
	        <div :class="['btn--code-normal',{'btn-code-gray':isCode}]" @click="sendCode()"  style="margin-left:">{{numsStr}}</div>
		    <!-- <div class="code-box">
	            <label>验证码</label>
	            <input name="code" v-model="code" type="tel" placeholder="短信验证码">
	            <div class="btn-code" @click="sendCode()">{{numsStr}}</div>
	        </div> -->
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				telReg : /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/,
				numsStr:"60s后重新获取",
				nums:60,
				clock:'',
				isClick:false,
				phone:'',
				phoneStr:'',
				code:'',
				isCode:true,
				codeLength:6,
				placeholder:'',
				codeNumber:''
			}
		},
		methods:{
			 hideKeyboard:function(){
				// 输入完成隐藏键盘
				document.activeElement.blur() // ios隐藏键盘
                this.$refs.input.blur() // android隐藏键盘
                this.validate();
			},
			handleInput:function(e){
				this.$refs.input.value = this.codeNumber
					if (this.codeNumber.length >= this.codeLength) {
					this.hideKeyboard()
				}
			},
			upNmuber:function(){
				var _this = this;
				this.clock = setInterval(function(){
					_this.nums--;	
					console.log(_this.nums);
					if(_this.nums > 0){
						_this.isCode = true
						_this.numsStr = _this.nums+"秒后重新获取"
					}else{
						_this.isCode = false
						_this.isClick = false;
						clearInterval(_this.clock); //清除js定时器
						_this.nums = 60; //重置时间
						_this.numsStr = "重新获取";
						clearInterval(_this.clock); //清除js定时器
					}
				}, 1000); //一秒执行一次
			},
			validate:function(){
                var _this = this;
                _this.code = _this.codeNumber;
				if('' == this.code){
					return weui.alert("验证码不能为空");
				}
				 _this.$axios.post(_this.twapiUrl + "/teacher/modify-phone",
				 _this.$qs.stringify({code:_this.code,phone:_this.phone}))
                .then(function (response) {
                	if(response.data.success){
                		_this.$router.push('/teacher/user/phone-succeed/'+_this.phone);
                		clearInterval(_this.clock);
					}else{
						weui.alert(response.data.info);
					    return  _this.codeNumber = '';					    
					}
                }).catch(function (error) {
                    console.log(error);
                });
			},
			sendCode:function(){
				var _this = this;
				if (!this.telReg.test(this.phone)) {
					return weui.alert("手机号格式错误");
				}

             	if(this.isClick){
                	return;
              	}
                this.isClick = true;
				this.upNmuber();
                console.log("-----------------------------");
                _this.$axios.post(_this.twapiUrl + "/teacher/teacher-wechat-message",_this.$qs.stringify({phone:_this.phone}))
                .then(function (response) {
                	console.log("-----------------------------");
                	if(response.data.success){
						weui.toast('验证码发送成功');
					}else{
						weui.alert("发送失败");
					}
                }).catch(function (error) {
                    console.log(error);
                });
            },
		},
		watch: {
		   // 如果路由有变化，会再次执行该方法
		   '$route': 'focusMenu',
		},
		mounted(){
			this.phone = this.$route.params.phone;
			
			if(this.phone != 'unset'){
				
				var _this = this;
				console.log("-------------------->"+this.phone);
				this.phoneStr = '*******'+this.phone.substr(parseInt(this.phone.split('').length/2+2),this.phone.split('').length);
				this.sendCode();
			}
			
		},
		beforeDestroy(){
		},
		destroyed(){
			clearInterval(this.clock);
		}
	}
</script>

<style scoped>
.container{
	padding: 1rem 0 0 0; 
	height: 100vh;
	width: 100vw;
    background: #fff;
}

.btn--code-normal,.btn-code-gray{
  	width: 100%;
	height:0.44rem;
	font-size:0.32rem;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(3,187,181,1);
	line-height:0.44rem;
	margin-top: .5rem;
	text-align: left;
	/* margin-left: .3rem; */
	margin-left:0;
}
.btn-code-gray{
	color: #CCCCCC;
}

.code_box{
	padding-left: 0.5rem;
	width: calc(100vw - 0.5rem);
}

.telcode-box{
	/* padding-left: .42rem; */
	margin-top: 1rem;
	text-align: center;
}
.code-span{
	width:0.38rem;
	height:0.96rem;
	font-size:0.68rem;
	font-family:PingFangSC-Regular;
	font-weight:400;
	color:rgba(3,187,181,1);
	line-height:0.96rem;
	position: relative;
	display: inline-block;
	vertical-align: top;
	margin-right: 0.66rem;
}
.code-span::after{
	content: '';
	width:0.6rem;
	height:0.02rem;
	position: absolute;
	top: 1.16rem;
	left: -0.08rem;
	background: rgb(136, 136, 136);
}

.code-span.active::after{
	background: #03BBB5;
}
.input-code{
	position: absolute;
    left: 0;
    width: 100%;
    height: .6rem;
	top: 4.5rem;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/user/validate-new-phone.vue